import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Table, Icon } from "semantic-ui-react";

import { MediaAs } from "../../styles/Media";

import { getIconByType } from "../resources/resourceIcon/ResourceIconMap.js";

import { USER_RESOURCE_KEYS } from "../../constants/entity.js";

class ProjectRowHeader extends PureComponent {
  static propTypes = {
    copy: PropTypes.func.isRequired
  };

  // -- RENDER -- //

  renderResourceHeaders = () => {
    const test = USER_RESOURCE_KEYS.map(key => {
      return (
        <MediaAs
          as={Table.HeaderCell}
          greaterThan="smallTablet"
          collapsing
          key={`${key}-header`}
        >
          <Icon name={getIconByType(key)} />
        </MediaAs>
      );
    });

    console.log("renderResourceHeaders:", test);

    return test;
  };

  render() {
    const { copy } = this.props;

    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>{copy("projects.name")}</Table.HeaderCell>
          {this.renderResourceHeaders()}
          <Table.HeaderCell />
          <Table.HeaderCell />
        </Table.Row>
      </Table.Header>
    );
  }
}

export default ProjectRowHeader;
